import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';

import css from './ContactPage.module.css';
import image from './contact-banner.png';
import MessengerSection from './MessengerSection';
import ContactForm from './ContactForm';
import { sendEmailOnContactPage } from './ContactPage.duck';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import useLanguageByLocation from '../../util/hooks/useLanguageByLocation';

const ContactPageComponent = props => {
  const { inProgress, submitError, submitSucceed, intl, onSendEmailOnContactPage } = props;
  const submitErrorMessage = submitError && (
    <div className={css.error}>
      <FormattedMessage id="ContactPage.submitError" />
    </div>
  );

  const submitSucceedMessage = submitSucceed && (
    <div className={css.success}>
      <FormattedMessage id="ContactPage.submitSucceed" values={{ break: <br /> }} />
    </div>
  );

  const currentCountryCode = useLanguageByLocation().countryCode;

  const handleSendEmailOnContactPage = values => {
    return onSendEmailOnContactPage({ ...values, currentCountryCode });
  };

  const contactPageTitle = intl.formatMessage({ id: 'ContactPage.contactPageTitle' });
  const contactPageDescription = intl.formatMessage({ id: 'ContactPage.contactPageDescription' });
  return (
    <StaticPage
      title={contactPageTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Contact Page',
        description: contactPageDescription,
        name: contactPageTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            <FormattedMessage id="ContactPage.pageTitle" />
          </h1>
          <img className={css.coverImage} src={image} alt="My first ice cream." />
          <MessengerSection />

          <p className={css.formTitle}>
            <FormattedMessage id="ContactPage.formTitle" />
          </p>
          <ContactForm
            formId="ContactForm"
            intl={intl}
            inProgress={inProgress}
            submitSucceed={submitSucceed}
            onSubmit={handleSendEmailOnContactPage}
            submitErrorMessage={submitErrorMessage}
            submitSucceedMessage={submitSucceedMessage}
          />
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

ContactPageComponent.defaultProps = {
  inProgress: false,
  submitError: null,
  submitSucceed: false,
};

ContactPageComponent.propTypes = {
  inProgress: bool.isRequired,
  submitError: propTypes.error,
  submitSucceed: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { inProgress, submitError, submitSucceed } = state.ContactPage;
  return {
    inProgress,
    submitError,
    submitSucceed,
  };
};

const mapDispatchToProps = dispatch => ({
  onSendEmailOnContactPage: params => dispatch(sendEmailOnContactPage(params)),
});

const ContactPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ContactPageComponent);

export default ContactPage;
